import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const links = location.pathname === '/jobs'
    ? [
        { href: '/api/jobs', label: 'Jobs API' },
        { href: '/api/jobs/stats', label: 'Stats API' },
      ]
    : location.pathname === '/zoho-leads'
      ? [
          { href: '/api/zoho/summary', label: 'Leads API' },
          { href: '/api/zoho/charts', label: 'Charts API' },
        ]
      : [
          { href: '/api/data', label: 'Raw Data API' },
          { href: '/api/charts', label: 'Charts API' },
        ];

  return (
    <footer className="mt-5 bg-light py-4">
      <Container>
        <Row>
          <Col md={6}>
            <p className="mb-0">&copy; 2025 EH Immigration. All rights reserved.</p>
          </Col>
          <Col md={6} className="text-end">
            <small>
              {links.map((link, index) => (
                <React.Fragment key={link.href}>
                  {index > 0 && <span className="mx-1">|</span>}
                  <a href={link.href} target="_blank" rel="noopener noreferrer">
                    {link.label}
                  </a>
                </React.Fragment>
              ))}
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
